module.exports = {"otetsutabi":"おてつたび","shared":{"close":"閉じる"},"request":{"error":"エラーが発生しました。再度お試しください。"}}